import React, { useState } from 'react';
import { uniqueId } from '~/lib/uniqueId';
import { useToggleAudioEffect } from '../audio-effect/useToggleAudioEffect';
import { PickListItem } from './PickListItem';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ItemType = { [k: string]: any } | string | number;

interface PickListProps<T> {
  items: T[];
  selected?: T;
  onSelect(item: T): void;
  labelField?: string;
  valueField?: string;
  additionalField?: string;
  useSubtitle?: boolean;
}

function getVal<T extends ItemType>(item: T, fieldName?: string) {
  if (typeof item === 'string' || typeof item === 'number') return item;
  if (!fieldName) throw new Error('need field name for list of objects');
  return item[fieldName].toString();
}

export const PickList = <T extends ItemType>({
  items,
  selected,
  onSelect,
  labelField,
  valueField,
  useSubtitle,
  additionalField
}: PickListProps<T>) => {
  const [name] = useState(uniqueId('radio'));
  const [playAudioEffect] = useToggleAudioEffect();

  items = items.sort(function (a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  return (
    <>
      {items.map(i => {
        const value = getVal(i, valueField);
        const label = getVal(i, labelField);
        const additionalLabel = additionalField
          ? getVal(i, additionalField)
          : null;

        return (
          <PickListItem
            key={value}
            value={value}
            additionalValue={useSubtitle ? additionalLabel : ''}
            checked={selected === i}
            name={name}
            onChange={e => {
              try {
                playAudioEffect();
              } catch (error) {
                // Silently ignore audio effect errors
              }
              if (e.target.value === value) onSelect(i);
            }}
            onKeyPress={() => {
              try {
                playAudioEffect();
              } catch (error) {
                // Silently ignore audio effect errors
              }
              onSelect(i);
            }}
          >
            {label}
          </PickListItem>
        );
      })}
    </>
  );
};
